import React, { useState, useEffect, useCallback } from "react";
import CenterPaymentForm from "./CenterPaymentForm";
import { allSharedComponents } from "../../../shared";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { viewPathConstants } from "../../../constants";
import { authService } from "../../../services";
import { useDispatch, useSelector } from "react-redux";
import {
  centersActions,
  SubscriptionActions,
  paymentActions,
  authActions,
} from "../../../redux/actions";

import { CenterStatusEnum } from "../../../constants";
import { unloadWidget } from "../../../system";

const CenterPayment = () => {
  const { GeneralLogo, BaseForm, CustomModal } = allSharedComponents;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userData = useSelector((state) => state?.LoginReducer?.UserData);

  const [isShow, setShow] = useState(false);

  const onSetShow = () => {
    unloadWidget();
    dispatch(paymentActions.paymentCheckoutNull());
    setShow(true);
    if (isShow === true) {
      navigate(viewPathConstants.CENTER_PROFILE);
    }
  };

  useEffect(() => {
    if (
      userData?.centerStatus === CenterStatusEnum.PaymentRejected ||
      userData?.centerStatus === CenterStatusEnum.PaymentPending ||
      userData?.centerStatus === CenterStatusEnum.Restricted
    ) {
      onSetShow();
    } else {
      dispatch(paymentActions.paymentCheckoutNull());
      navigate(viewPathConstants.CENTER_PROFILE);
    }
    // eslint-disable-next-line
  }, [userData]);

  useEffect(() => {
    dispatch(centersActions.getCenterById(userData?.user?.centerId));
    dispatch(
      SubscriptionActions.GetAllSubscriptionPrices({ isLoading: false })
    );
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className="background-image">
        <CustomModal
          size="sm"
          show={isShow}
          scrollable={true}
          setShow={onSetShow}
          closeBtnClasses={"login-modal-close-btn"}
        >
          <BaseForm>
            <GeneralLogo />
            <CenterPaymentForm setShow={setShow} />
          </BaseForm>
        </CustomModal>
      </div>
    </>
  );
};

export default CenterPayment;
